import { makeGetRequest } from 'owa-ows-gateway';
import type { GetSavedCalendarViewsResponse } from '../store/schema/SaveCalendarViewConfig';
import { SAVE_CALENDAR_VIEW_API_BASE_URL } from '../utils/constants';

export async function getSavedCalendarViewsService(): Promise<GetSavedCalendarViewsResponse> {
    try {
        const response = await makeGetRequest(
            SAVE_CALENDAR_VIEW_API_BASE_URL,
            undefined /* correlationId */,
            true /* returnFullResponse */,
            undefined /* customHeaders */,
            undefined /* throwServiceError */,
            undefined /* includeCredentials */,
            'GET_SAVED_CALENDAR_VIEWS' /* actionName */
        );
        if (response.ok) {
            // disabling tslint rule as we need to await here
            // for the catch block to work properly
            // https://github.com/palantir/tslint/issues/3933
            // tslint:disable-next-line:no-return-await
            return await response.json();
        } else {
            return null;
        }
    } catch {
        return null;
    }
}
